module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationpage",
    attrs: {
      "id": "d7e92"
    }
  }, [_c('h1', {
    staticClass: "chapno"
  }), _c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "d7e93"
    }
  }, [_c('p', {
    staticClass: "dedicationtext"
  }, [_c('b', [_c('i', [_vm._v("I dedicate this book, and my life, "), _c('br'), _vm._v("to my precious daughter Emily. "), _c('br'), _vm._v("I love you more than cookie dough.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670264c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kime_9781440501951_epub_ded.vue
// module id = 69
// module chunks = 0